import { useEffect, useState } from 'react';
type Theme = 'light' | 'dark';

const mq = window.matchMedia('(prefers-color-scheme: dark)');

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() =>
    mq.matches ? 'dark' : 'light'
  );

  // Apply class + sync localStorage whenever theme changes
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Real-time OS preference listener
  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? 'dark' : 'light');
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');
  return { theme, toggleTheme };
};
